import styled, { css } from "styled-components";
import { buildColor, breakpoints } from "@tvg/design-system";

export const WarningContainer = styled.div<{
  isBetSlipExpanded?: boolean;
  isFloating?: boolean;
}>`
  padding-right: ${({ theme, isFloating }) =>
    isFloating ? theme.space["space-4"] : 0};
  padding-left: ${({ theme, isFloating }) =>
    isFloating ? theme.space["space-4"] : 0};
  transition: padding-left 0.2s linear;

  @media screen and ${breakpoints.desktop.min.xl} {
    ${({ isFloating, isBetSlipExpanded }) =>
      isFloating &&
      css`
        padding-left: ${isBetSlipExpanded
          ? "90px"
          : "calc(var(--lhn-width, 292px) + 28px)"};
      `};
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

export const WarningWrapper = styled.div<{ isFloating?: boolean }>`
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${buildColor("red", "000")};
  border-top-left-radius: ${({ isFloating }) => (isFloating ? "4px" : 0)};
  border-top-right-radius: ${({ isFloating }) => (isFloating ? "4px" : 0)};
  border: 1px solid ${buildColor("red", "100")};
`;
